angular.module('Entities')
    .filter('mask', ['$filter',
        function ($filter) {
            return function (text, mask, type, description) {
                if (text) {
                    switch (type) {
                        case 'date':
                            text = $filter('date')(text, mask || "dd/MM/yyyy");
                            break;
                    }

                    if (description) {
                        text = text + ' - ' + description;
                    }

                    if (type != 'date' && mask) {
                        text = applyMask(text, mask)
                    }
                }

                return text;
            }

            function applyMask(text, mask) {
                var delimiter = mask.indexOf('-') != -1 ? '-' : '/';

                var maskAux = mask;

                maskAux = maskAux.replace(/[?]/g, '');

                var indices = [];
                var count = 0;

                for (var i = 0; i < maskAux.length; i++) {
                    if (maskAux[i] === delimiter) {
                        indices.push(i - count);
                        count++;
                    };
                }

                var aux = '';
                var auxindex = 0;
                indices.forEach(function (index) {
                    aux += text.slice(auxindex, index) + delimiter;
                    auxindex = index;
                });

                aux += text.slice(auxindex);

                return aux;
            };
        }])